import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap["firestore-security-rules"] = bracketIndenting({
	line: "//",
})
